// True while scripts/prerender.mjs is rendering the page in headless Chrome.
// Live data, third-party widgets and consent UI are skipped in that mode so
// the saved HTML is static and identical for every visitor.
export const isPrerender = () =>
  typeof window !== "undefined" && window.__PRERENDER__ === true;
